<template>
    <div class="advantage" :style="{backgroundImage: 'url(' + imgBg + ')'}">
        <div class="title">
            <div class="title-content">
                优势特点
            </div>
        </div>
        <div class="cards" id="cards">
            <div class="box" @mouseenter="mouseover(index)" @mouseleave="mouseout(index)" v-for="(card,index) in cards" >
                <card :img="card.img" :title="card.title" :active="card.active" :msg="card.msg"/>
            </div>

<!--            <div class="card">-->
<!--                <div class="img">-->
<!--                    <img :src="img2">-->
<!--                </div>-->
<!--                <div class="stick">-->
<!--                </div>-->
<!--                <div class="title1">-->
<!--                    <div class="title-content1">灵活定制</div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--                <div class="img">-->
<!--                    <img :src="img3">-->
<!--                </div>-->
<!--                <div class="stick">-->
<!--                </div>-->
<!--                <div class="title1">-->
<!--                    <div class="title-content1">安全可控</div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--                <div class="img">-->
<!--                    <img :src="img4">-->
<!--                </div>-->
<!--                <div class="stick">-->
<!--                </div>-->
<!--                <div class="title1">-->
<!--                    <div class="title-content1">数据智能</div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--                <div class="img">-->
<!--                    <img :src="img5">-->
<!--                </div>-->
<!--                <div class="stick">-->
<!--                </div>-->
<!--                <div class="title1">-->
<!--                    <div class="title-content1">服务生态</div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--                <div class="img">-->
<!--                    <img :src="img6">-->
<!--                </div>-->
<!--                <div class="stick">-->
<!--                </div>-->
<!--                <div class="title1">-->
<!--                    <div class="title-content1">备件溯源</div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    import imgBg from '@/assets/index/img/BG-优势特点.png'
    import img1 from '@/assets/index/img/advantage/设备物联.png'
    import img2 from '@/assets/index/img/advantage/灵活定制.png'
    import img3 from '@/assets/index/img/advantage/安全可控.png'
    import img4 from '@/assets/index/img/advantage/数据智能.png'
    import img5 from '@/assets/index/img/advantage/服务生态.png'
    import img6 from '@/assets/index/img/advantage/备件溯源.png'
    import card from "./components/card";

    export default {
        name: "advantage",
        components:{
            card
        },
        data(){
            return{
                width:document.body.clientWidth,
                imgBg:imgBg,
                img1:img1,
                img2:img2,
                img3:img3,
                img4:img4,
                img5:img5,
                img6:img6,
                cards:[{
                    active:null,
                    title:'设备物联',
                    img:img1,
                    msg:['技术团队自主研发',
                    '支持多种设备接入方式']
                },{
                    active:null,
                    title:'灵活定制',
                    img:img2,
                    msg:['专业产品团队',
                        '根据企业特点及行业属性量身打造']
                },{
                    active:null,
                    title:'安全可控',
                    img:img3,
                    msg:['核心技术自主开发',
                        '平台功能安全可控']
                },{
                    active:null,
                    title:'数据智能',
                    img:img4,
                    msg:['人工智能技术加持',
                        '提升平台智能运营能力']
                },{
                    active:null,
                    title:'服务生态',
                    img:img5,
                    msg:['平台生态化运营策略',
                        '长期合作运营','共同挖掘后市场潜能']
                },{
                    active:null,
                    title:'备件溯源',
                    img:img6,
                    msg:['备件防伪溯源体系，一物一码品质管控']
                }],

            }
        },
        created(){
            this.width=document.body.clientWidth
        },
        mounted(){
            window.addEventListener('resize', this.handelWidth, false)
            this.handelWidth()
        },
        beforeDestroy(){
            window.removeEventListener("resize",this.handelWidth, false)
        },
        methods:{
            mouseover(i){
                this.cards[i].active=true;
            },
            mouseout(i){
                this.cards[i].active=false
            },
            handelWidth(){
                this.width=document.body.clientWidth
                let w=document.body.clientWidth
                let box=document.getElementsByClassName("box")
                let cards=document.getElementById("cards")
                if(w>1900){
                    cards.style.paddingLeft="25%"
                    cards.style.paddingRight="10%"
                }else if(1700<w&&w<=1900){
                    cards.style.paddingLeft="24%"
                    cards.style.paddingRight="10%"
                }else if(1500<w&&w<=1700){
                    cards.style.paddingLeft="20%"
                }else if(1300<w&&w<=1500){
                    cards.style.paddingLeft="13%"
                }else if(1100<w&&w<=1300){
                    cards.style.paddingLeft="5%"
                    cards.style.paddingRight="5%"
                }

            }
        }
    }
</script>

<style scoped>
    .advantage{
        width:100%;
        height:700px;
        position: relative;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        -ms-background-size: cover;
        background: no-repeat center;
        background-size: cover;
        overflow: auto;
    }
    .title{
        position: absolute;
        width: 100%;
        top: 65px;
    }
    .title-content{
        position: relative;
        margin: 0 auto;
        width:180px;
        height:50px;
        font-size:36px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:50px;
        color:rgba(255,255,255,1);
        letter-spacing:9px;
        opacity:1;
    }
    .cards{
        position: absolute;
        padding-left: 15%;
        padding-right: 10%;
        top: 175px;
    }
    .card-body{
        position: absolute;
        /*margin: 0 auto;*/
        /*padding-left:10%;*/
        margin-left:9% ;
        /*padding:0 auto;*/
        /*left: auto;*/
    }
    .box{
        position: relative;
        /*margin: 0 auto;*/
        float: left;
        width:300px;
        /*min-width: 260px;*/
        height:200px;
        margin: 10px;
    }
    .img{
        /*background: rgb(255, 255, 255);*/
        position: relative;
        top: 50px;
        left: 155px;
        width:50px;
        height:50px;
    }
    .stick{
        position: absolute;
        left: 164px;
        width:32px;
        height:2px;
        background: rgb(255, 255, 255);
        opacity:10;
        top: 115px;
    }
    .title1{
        position: absolute;
        width: 100%;
        top: 141px;
    }
    .title-content1{
        left: 140px;
        position: relative;
        width:80px;
        height:27px;
        font-size:20px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:27px;
        color:rgba(255,255,255,1);
        letter-spacing:0px;
        opacity:10;
    }


</style>
